import { ModalId } from '../../../../../../../../../enums/modalId'

export const getCurrencyMismatchModalId = (transactionId?: string): string => {
  return `${ModalId.BankTransactionCurrencyMismatchModal}-${transactionId}`
}
